class DrawerSearchSection extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.drawerClass = "wt-drawer-search";
    this.drawer = document.querySelector(`.${this.drawerClass}`);
    this.classDrawerActive = `${this.drawerClass}--active`;
    this.pageOverlayClass = "search-overlay";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;

    this.triggerQuery = [
      ".wt-header__search-trigger",
      ".wt-header__search__close",
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);

    // search stuff
    this.cachedResults = {};
    this.fetchAbortController = null;
    this.input = this.querySelector('input[name="q"]');
    this.clearButton = this.querySelector(".wt-header__search__clear-button");
    this.closeButton = this.querySelector(".wt-header__search__close");
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]",
    );
    this.mainTrigger = this.querySelector(".wt-header__search-trigger");
    this.emptyAnnouncement = this.querySelector(".search-empty");

    this.isVisibleClearButton = false;

    this.saveSuggestionMenuInDesignMode =
      this.saveSuggestionMenuInDesignMode.bind(this);
    this.setupEventListeners();

    this.toggleTabindexElements = [this.input, this.closeButton];

    this.init();
  }

  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input:not([type='hidden']), select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  // fixOverlayIssue() {
  //     const body = this.body;
  //
  //     if(body.classList.contains(this.activeOverlayBodyClass)) {
  //         const offsetTop = -parseInt(body.style.top);
  //         body.style.position = 'initial';
  //         body.style.top = 'initial';
  //         body.style.left = 'initial';
  //         window.scrollTo(0, offsetTop);
  //
  //     } else {
  //         // body.style.top = -document.documentElement.scrollTop+'px';
  //         // body.style.left = '0px';
  //         // body.style.position = 'fixed';
  //     }
  // }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      setTabindex(this.toggleTabindexElements, "-1");
      setTabindex([this.mainTrigger], "0");
      this.isOpen = false;
      setTimeout(() => {
        this.mainTrigger.focus();
      }, 0);
    } else {
      this.setAttribute("open", "");
      setTabindex(this.toggleTabindexElements, "0");
      setTabindex([this.mainTrigger], "-1");
      this.input.focus();
      this.isOpen = true;
    }
  }

  toggleDrawerClasses() {
    this.onToggle();
    // this.fixOverlayIssue();
    this.drawer.classList.toggle(this.classDrawerActive);
    this.body.classList.toggle(this.activeOverlayBodyClass);
  }

  init() {
    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDrawerClasses();
      });
    });

    this.clearButton.addEventListener("click", () => {
      this.input.value = "";
      this.clearButton.style.display = "none";
      this.isVisibleClearButton = false;
      this.clearResults();
    });

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleDrawerClasses();
        }
      }

      if (isTabPressed) {
        if (this.isOpen) {
          if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    });

    this.input.addEventListener("input", () => {
      if (this.input.value.length > 0 && !this.isVisibleClearButton) {
        this.clearButton.style.display = "flex";
        this.clearButton.setAttribute("tabindex", "0");
        this.isVisibleClearButton = true;
      } else if (this.input.value.length === 0 && this.isVisibleClearButton) {
        this.clearButton.style.display = "none";
        this.clearButton.setAttribute("tabindex", "-1");
        this.isVisibleClearButton = false;
      }
    });
  }

  // search stuff
  setupEventListeners() {
    const form = this.querySelector("form.store-search-form");
    form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    if (Shopify.designMode) {
      document.addEventListener(
        "shopify:section:load",
        this.saveSuggestionMenuInDesignMode,
      );
    }
  }

  saveSuggestionMenuInDesignMode() {
    if (this.body.classList.contains(this.activeOverlayBodyClass))
      this.drawer.classList.toggle(this.classDrawerActive);
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (searchTerm.length) {
      this.getSearchResults(searchTerm);
      this.removeAttribute("empty");
    } else {
      this.clearResults();
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
  }

  escapeHtml(str) {
    if (str == null) return "";
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  sanitizeAttrUrl(url) {
    const s = String(url || "").trim();
    if (!s || s === "#") return "#";
    if (
      s.startsWith("/") ||
      s.startsWith("http://") ||
      s.startsWith("https://")
    ) {
      return s.replace(/"/g, "&quot;");
    }
    return "#";
  }

  extractPredictiveSectionHtml(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    let el = doc.querySelector("#shopify-section-predictive-search");
    if (!el) {
      const inner = doc.querySelector("#predictive-search-results");
      let p = inner?.parentElement;
      while (p && p !== doc.body) {
        if (p.id?.startsWith("shopify-section-")) {
          el = p;
          break;
        }
        p = p.parentElement;
      }
    }
    return el ? el.innerHTML : null;
  }

  async fetchSuggestJsonAsMarkup(searchTerm, signal) {
    const predictiveUrl =
      window.routes?.predictive_search_url || "/search/suggest";
    let origin;
    try {
      origin = new URL(predictiveUrl, window.location.origin).origin;
    } catch {
      origin =
        (window.shopUrl || "").replace(/\/$/, "") || window.location.origin;
    }

    const paths = [];
    try {
      const u = new URL(predictiveUrl, window.location.origin);
      if (u.pathname.endsWith("/search/suggest")) {
        const withoutLocale = u.pathname.replace(
          /^\/[a-z]{2}(?:-[a-zA-Z0-9]+)?(?=\/search\/suggest$)/,
          "",
        );
        const jsonPath = `${withoutLocale}.json`;
        if (!paths.includes(jsonPath)) paths.push(jsonPath);
      }
    } catch {
      /* ignore */
    }
    for (const p of ["/search/suggest.json", "/en/search/suggest.json"]) {
      if (!paths.includes(p)) paths.push(p);
    }

    const params = new URLSearchParams({
      q: searchTerm,
      "resources[type]": "product",
      "resources[limit]": "10",
      "resources[limit_scope]": "each",
      "resources[options][fields]": "title,variants.sku,product_type,body,tag,vendor",
    });
    const qs = params.toString();
    let lastStatus = 0;
    for (const path of paths) {
      const url = `${origin}${path}?${qs}`;
      const r = await fetch(url, { signal });
      lastStatus = r.status;
      if (!r.ok) continue;
      let data;
      try {
        data = await r.json();
      } catch {
        continue;
      }
      return this.buildMarkupFromSuggestionsJson(data, searchTerm);
    }
    throw new Error(String(lastStatus || 500));
  }

  /**
   * Full storefront search HTML (works for locales where predictive search returns 417).
   */
  async fetchStorefrontSearchMarkup(searchTerm, signal) {
    const searchUrl = window.routes?.search_url || "/search";
    const sep = searchUrl.includes("?") ? "&" : "?";
    const url = `${searchUrl}${sep}q=${encodeURIComponent(searchTerm)}&type=product`;
    const r = await fetch(url, {
      signal,
      credentials: "same-origin",
      headers: { Accept: "text/html" },
    });
    if (!r.ok) throw new Error(String(r.status));
    const html = await r.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const grid =
      doc.querySelector("#product-grid") ||
      doc.querySelector(".collection__grid--search-category.active") ||
      doc.querySelector(".collection__grid--search-category");
    const label = this.getAttribute("data-products-label") || "Products";
    const noResultsTpl = this.getAttribute("data-no-results-msg") || "";
    const searchForTpl = this.getAttribute("data-search-for-label") || "";
    const qEsc = this.escapeHtml(searchTerm);
    const noResultsMsg = noResultsTpl.replace(/__QUERY__/g, qEsc);
    const searchForLabel = searchForTpl.replace(/__QUERY__/g, qEsc);
    const viewAllHrefAttr = this.sanitizeAttrUrl(url);

    if (!grid) {
      return `<span data-predictive-search-live-region-count-value>${noResultsMsg}</span>`;
    }

    const directItems = Array.from(grid.children).filter((el) =>
      el.classList?.contains("collection__grid__item"),
    );
    const looseItems = directItems.length
      ? directItems.slice(0, 8)
      : Array.from(grid.querySelectorAll(".collection__grid__item")).slice(
          0,
          8,
        );

    if (looseItems.length === 0) {
      return `<span data-predictive-search-live-region-count-value">${noResultsMsg}</span>`;
    }

    const rows = looseItems.map((el) => el.outerHTML).join("");
    return `<div id="predictive-search-results" class="search-result search-result--storefront-fallback"><div class="search-result-products"><div id="predictive-search-products" class="search-result__title">${label}</div><div class="search-drawer-storefront-grid collection__grid">${rows}</div><div class="search-result-more" role="option"><a href="${viewAllHrefAttr}" class="search-result-more__link" tabindex="0">${searchForLabel}</a></div></div></div>`;
  }

  buildMarkupFromSuggestionsJson(data, searchTerm) {
    const raw = data?.resources?.results?.products;
    const products = Array.isArray(raw) ? raw : [];
    const label = this.getAttribute("data-products-label") || "Products";
    const noResultsTpl = this.getAttribute("data-no-results-msg") || "";
    const searchForTpl = this.getAttribute("data-search-for-label") || "";
    const qEsc = this.escapeHtml(searchTerm);
    const noResultsMsg = noResultsTpl.replace(/__QUERY__/g, qEsc);
    const searchForLabel = searchForTpl.replace(/__QUERY__/g, qEsc);
    const searchUrl = window.routes?.search_url || "/search";
    const viewAllHref = `${searchUrl}?q=${encodeURIComponent(searchTerm)}&type=product`;
    const viewAllHrefAttr = this.sanitizeAttrUrl(viewAllHref);

    if (!products.length) {
      return `<span data-predictive-search-live-region-count-value>${noResultsMsg}</span>`;
    }

    const items = products
      .map((product, index) => {
        const title = this.escapeHtml(product.title || "");
        const href = this.sanitizeAttrUrl(product.url);
        const imgUrl =
          product.featured_image?.url ||
          (typeof product.image === "string" ? product.image : "") ||
          "";
        const imgBlock =
          imgUrl && /^https?:\/\//.test(imgUrl)
            ? `<figure class="wt-cart__item__thumb suggest-item__thumb"><img src="${this.sanitizeAttrUrl(imgUrl)}" alt="${title}" loading="lazy" width="150" height="150"></figure>`
            : "";
        let priceBlock = "";
        if (product.price != null && product.price !== "") {
          const p =
            typeof product.price === "number"
              ? product.price.toFixed(2)
              : String(product.price);
          priceBlock = `<div class="wt-cart__item__price">${this.escapeHtml(p)}</div>`;
        }
        return `<li id="predictive-search-option-json-${index + 1}" class="search-result-list__item" role="option" aria-selected="false"><a href="${href}" class="suggest-item">${imgBlock}<div class="wt-cart__item__body suggest-item__body"><div class="wt-cart__item__data"><h3 class="wt-cart__item__name">${title}</h3>${priceBlock}</div></div></a></li>`;
      })
      .join("");

    return `<div id="predictive-search-results" class="search-result"><div class="search-result-products"><div id="predictive-search-products" class="search-result__title">${label}</div><ul id="predictive-search-results-list" class="search-result-list" role="listbox" aria-labelledby="predictive-search-products">${items}</ul><div class="search-result-more search-result-more--desktop" role="option"><a href="${viewAllHrefAttr}" class="search-result-more__link" tabindex="0">${searchForLabel}</a></div></div></div><div class="search-result-more" role="option"><a href="${viewAllHrefAttr}" class="search-result-more__link" tabindex="-1">${searchForLabel}</a></div>`;
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(/\s+/g, "-").toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    this.setLiveRegionLoadingState();

    if (this.fetchAbortController) {
      this.fetchAbortController.abort();
    }
    this.fetchAbortController = new AbortController();
    const { signal } = this.fetchAbortController;

    const predictiveBase =
      window.routes?.predictive_search_url || "/search/suggest";
    const htmlUrl = `${predictiveBase}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product,page,article,collection,query&${encodeURIComponent("resources[limit_scope]")}=each&${encodeURIComponent("resources[limit]")}=10&${encodeURIComponent("resources[options][fields]")}=title,variants.sku,product_type,body,tag,vendor&section_id=predictive-search`;

    fetch(htmlUrl, { signal })
      .then((response) =>
        response.text().then((text) => ({ ok: response.ok, text })),
      )
      .then(({ ok, text }) => {
        if (ok) {
          const markup = this.extractPredictiveSectionHtml(text);
          if (markup != null && markup.trim() !== "") {
            return markup;
          }
        }
        return this.fetchSuggestJsonAsMarkup(searchTerm, signal);
      })
      .catch((err) => {
        if (err.name === "AbortError") throw err;
        return this.fetchStorefrontSearchMarkup(searchTerm, signal);
      })
      .then((resultsMarkup) => {
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        this.removeAttribute("loading");
        const errMsg =
          this.getAttribute("data-error-text") ||
          "Could not load results. Please try again.";
        this.renderSearchResults(
          `<p class="predictive-search__error" data-predictive-search-live-region-count-value>${this.escapeHtml(errMsg)}</p>`,
        );
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText ?? "";

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.setAttribute("results", true);

    this.setLiveRegionResults();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        ?.textContent,
    );
  }

  clearResults() {
    this.input.value = "";
    this.predictiveSearchResults.innerHTML = "";
    this.removeAttribute("results");
    this.setAttribute("empty", true);
  }
}

customElements.define("search-drawer", DrawerSearchSection);
